"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.registerBmFormContainer = exports.BmFormContainerElement = void 0;

var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/taggedTemplateLiteral"));

var _stringify = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/json/stringify"));

var _keys = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/object/keys"));

var _concat = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/concat"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/createClass"));

var _get2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/get"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/inherits"));

var _createSuper2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/createSuper"));

var _element = require("@blue/element");

var _utils = require("../../utils");

var _validators = require("../validators");

var _itemFactory = require("./items/item-engine/item-factory");

var _bmFormValues = require("./bm-form-values");

var _bmFormEvents = require("./bm-form-events");

var _formDefaultEngine = require("./items/form-default-engine");

var _itemRenderer = require("./items/item-engine/item-renderer");

function _templateObject() {
  var data = (0, _taggedTemplateLiteral2.default)(["\n\t\t\t<form>\n\t\t\t\t", "\n\t\t\t</form>\n\t\t"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var BmFormContainerElement = /*#__PURE__*/function (_bmFormEventDispatche) {
  (0, _inherits2.default)(BmFormContainerElement, _bmFormEventDispatche);

  var _super = (0, _createSuper2.default)(BmFormContainerElement);

  function BmFormContainerElement() {
    var _context;

    var _this;

    (0, _classCallCheck2.default)(this, BmFormContainerElement);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, (0, _concat.default)(_context = [this]).call(_context, args));
    _this.createItem = _itemFactory.createItem;
    _this.renderItem = _itemRenderer.renderItem;
    _this.getValue = _bmFormValues.getValue;
    _this.service = {
      readonlyForm: function readonlyForm() {
        var fields = _this.valuedFields(_this.info, false);

        var change1 = {
          propPath: 'previouslyReadonly',
          valuePath: 'readonly'
        };
        var change2 = {
          propPath: 'readonly',
          value: true
        };
        _this.info = _this.applyChanges(_this.info, fields, change1, change2);
      },
      unreadonlyForm: function unreadonlyForm() {
        var fields = _this.valuedFields(_this.info, false);

        var change1 = {
          propPath: 'readonly',
          valuePath: 'previouslyReadonly'
        };
        var change2 = {
          propPath: 'previouslyReadonly',
          value: undefined
        };
        _this.info = _this.applyChanges(_this.info, fields, change1, change2);
      },
      disableForm: function disableForm() {
        _this.disabled = true;

        _this._updateDisabled(_this.disabled);
      },
      enableForm: function enableForm() {
        _this.disabled = false;

        _this._updateDisabled(_this.disabled);
      },
      touchForm: function touchForm() {
        _this.info = _this.markFormAsTouched(_this.info);
      },
      isValid: function isValid() {
        var displayedErrors = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

        var getAllInputErrors = function getAllInputErrors(inputInfo) {
          return (0, _validators.getInputErrors)(inputInfo, {
            displayedErrors: displayedErrors,
            shortCircuit: true
          });
        };

        var errors = (0, _validators.getFormErrors)(_this.info, {
          shortCircuit: true,
          _getInputErrors: getAllInputErrors
        });
        return !errors;
      },
      getErrors: function getErrors() {
        var displayedErrors = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
        var shortCircuit = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

        var getAllInputErrors = function getAllInputErrors(inputInfo) {
          return (0, _validators.getInputErrors)(inputInfo, {
            displayedErrors: displayedErrors,
            shortCircuit: shortCircuit
          });
        };

        var errors = (0, _validators.getFormErrors)(_this.info, {
          _getInputErrors: getAllInputErrors
        });
        return errors;
      },
      getValue: function getValue() {
        var formVal = (0, _bmFormValues.getValue)(_this.info);
        return formVal;
      }
    };
    _this.serviceRef = void 0;
    return _this;
  }

  (0, _createClass2.default)(BmFormContainerElement, [{
    key: "shouldUpdate",
    value: function shouldUpdate(changedProps) {
      try {
        if (changedProps.has('serviceRef') && this.serviceRef) {
          this.serviceRef(this.service);
        }

        if (!this.items || (0, _keys.default)(this.items).length === 0 || !this.layout || (0, _keys.default)(this.layout).length === 0) {
          return false;
        }

        if (this._triggerReInit(changedProps)) {
          this._reinitializeForm(this.items, this.layout, this.data);
        } else {
          this._updateForm(changedProps);
        }
      } catch (error) {
        console.error(error);
        return false;
      }

      return (0, _get2.default)((0, _getPrototypeOf2.default)(BmFormContainerElement.prototype), "shouldUpdate", this).call(this, changedProps);
    }
  }, {
    key: "_triggerReInit",
    value: function _triggerReInit(changedProps) {
      return changedProps.has('items');
    }
  }, {
    key: "_triggerReLayout",
    value: function _triggerReLayout(changedProps) {
      return changedProps.has('layout');
    }
  }, {
    key: "_triggerValuePatch",
    value: function _triggerValuePatch(changedProps) {
      return changedProps.has('data');
    }
  }, {
    key: "_triggerToggleDisabled",
    value: function _triggerToggleDisabled(changedProps) {
      return changedProps.has('disabled') && Boolean(changedProps.get('disabled')) !== Boolean(this.disabled);
    }
  }, {
    key: "_reinitializeForm",
    value: function _reinitializeForm(items, layout, data) {
      this.info = this.createForm(items, layout, data);
      this.dispatchBmFormEvent({
        type: 'init'
      });

      if (this.disabled) {
        this._updateDisabled(true);
      }
    }
  }, {
    key: "_updateForm",
    value: function _updateForm(changedProps) {
      if (this._triggerReLayout(changedProps)) {
        this._updateLayout(this.layout);
      }

      if (this._triggerValuePatch(changedProps)) {
        try {
          var changes = this.collectChanges(this.info, this.info.fullyResolvedName, this.data);
          this.info = this.patchFormValues(this.info, changes);
        } catch (error) {
          console.error('error during patching form');
          throw error;
        }
      }

      if (this._triggerToggleDisabled(changedProps)) {
        this._updateDisabled(this.disabled);
      }
    }
  }, {
    key: "createForm",
    value: function createForm(items, layout, data) {
      var _context2;

      var validConfig = Boolean(items) && Boolean(layout);

      if (validConfig) {
        return this._createForm(items, layout, data || {});
      }

      throw new Error((0, _concat.default)(_context2 = "invalid config: items: ".concat((0, _stringify.default)(items), "; layout: ")).call(_context2, (0, _stringify.default)(layout)));
    }
  }, {
    key: "_createForm",
    value: function _createForm(items, layoutInfo, values) {
      var formRoot = {
        name: _utils.formRootName,
        type: 'form',
        options: {
          items: items
        }
      };
      var formItem = this.createItem(formRoot, null, layoutInfo, values);
      return formItem;
    }
  }, {
    key: "_updateLayout",
    value: function _updateLayout(newLayout) {
      var data = (0, _bmFormValues.getValue)(this.info, {
        overrideAvailable: true,
        overrideDisabled: true,
        overrideDisplayed: true
      });

      this._reinitializeForm(this.items, newLayout, data);
    }
  }, {
    key: "_updateDisabled",
    value: function _updateDisabled(disable) {
      this.info = this._toggleDisabled(this.info, disable);
    }
  }, {
    key: "_toggleDisabled",
    value: function _toggleDisabled(_form, newDisabled) {
      return newDisabled ? this.createDisableForm(_form) : this.createEnabledForm(_form);
    }
  }, {
    key: "createDisableForm",
    value: function createDisableForm(rootFormInfo) {
      var fieldsToDisable = this.valuedFields(rootFormInfo);
      var change1 = {
        propPath: 'previouslyDisabled',
        valuePath: 'disabled'
      };
      var change2 = {
        propPath: 'disabled',
        value: true
      };
      return this.applyChanges(rootFormInfo, fieldsToDisable, change1, change2);
    }
  }, {
    key: "createEnabledForm",
    value: function createEnabledForm(rootFormInfo) {
      var fieldsToEnable = this.valuedFields(rootFormInfo);
      var change1 = {
        propPath: 'disabled',
        valuePath: 'previouslyDisabled'
      };
      var change2 = {
        propPath: 'previouslyDisabled',
        value: null
      };
      return this.applyChanges(rootFormInfo, fieldsToEnable, change1, change2);
    }
  }, {
    key: "markFormAsTouched",
    value: function markFormAsTouched(rootFormInfo) {
      return this.applyChanges(rootFormInfo, this.valuedFields(rootFormInfo), {
        propPath: 'touched',
        value: true
      });
    }
  }, {
    key: "render",
    value: function render() {
      return this.html(_templateObject(), this.info ? this.renderItem(this.info) : null);
    }
  }], [{
    key: "is",
    get: function get() {
      return 'bm-form-container';
    }
  }, {
    key: "properties",
    get: function get() {
      return {
        items: {
          type: Object,
          attribute: false,
          reflect: false
        },
        layout: {
          type: Object,
          attribute: false,
          reflect: false
        },
        data: {
          type: Object,
          attribute: false,
          reflect: false
        },
        disabled: {
          type: Boolean,
          attribute: true,
          reflect: true
        },
        serviceRef: {
          type: Object,
          attribute: false,
          reflect: false
        },
        info: {
          type: Object,
          attribute: false,
          reflect: false
        }
      };
    }
  }]);
  return BmFormContainerElement;
}((0, _bmFormEvents.bmFormEventDispatcher)((0, _bmFormEvents.bmFormEventListener)(_itemRenderer.BmItemElement)));

exports.BmFormContainerElement = BmFormContainerElement;

var registerBmFormContainer = function registerBmFormContainer() {
  (0, _element.register)(BmFormContainerElement);
  (0, _formDefaultEngine.registerBmFormItem)();
};

exports.registerBmFormContainer = registerBmFormContainer;
